<template>
    <a
        href="#"
        :class="['af-btn-save-job', 'afu-p-2', 'afu-text-xl', { 'is-saved': isSavedJob }]"
        @click.stop.prevent="onClick()"
    >
        <template v-if="isSavedJob">
            <FontAwesomeIcon
                :icon="['fas', 'heart']"
                class="afu-text-danger-400"
            />
        </template>

        <template v-else>
            <FontAwesomeIcon
                :icon="['far', 'heart']"
                class="afu-text-primary-dark"
            />
        </template>
    </a>
</template>

<script>
    import { mapState, mapActions, mapMutations } from 'vuex';
    // import C1Button from '@/components/C1Components/C1Button';

    export default {
        name: 'SaveJobMobile',

        components: {
            // C1Button,
        },

        props: {
            jobUuid: {
                type: String,
                default: '',
            },

            size: {
                type: String,
                default: 'md',
                validator: value => ['sm', 'lg', 'md', 'xl'].includes(value),
            },
            variant: {
                type: String,
                default: 'neutral',
            },
        },

        data() {
            return {
                spinner: false,
            };
        },

        computed: {
            ...mapState({
                $_me: state => state.me,
                $_meJobEvents: state => state.me.jobEvents,
            }),

            isSavedJob() {
                const job = this.$_meJobEvents.find(o => o.job_uuid === this.jobUuid);
                return job && job.is_saved;
            },
        },

        created() {
            const saveJobUuId = this.$_me.saveJobAfterLogin;
            if (saveJobUuId && saveJobUuId === this.jobUuid) {
                this.saveJob();
            }
        },

        methods: {
            ...mapActions('me', {
                $_storeSavedJob: 'storeSavedJob',
                $_destroySavedJob: 'destroySavedJob',
            }),

            ...mapMutations('me', {
                $_DESTROY_SAVED_JOB: 'DESTROY_SAVED_JOB',
                $_SAVE_JOB_AFTER_LOGIN: 'SAVE_JOB_AFTER_LOGIN',
                $_PUT_JOB_EVENT: 'PUT_JOB_EVENT',
            }),

            onClick() {
                if (this.$_me.user.id) {
                    if (this.isSavedJob) {
                        this.destroySavedJob();
                    } else {
                        this.saveJob();
                    }
                } else {
                    this.$_SAVE_JOB_AFTER_LOGIN(this.jobUuid);
                    window.location.href = `/user-login?redirect=${window.location.pathname}`;
                }
            },

            saveJob() {
                this.spinner = true;
                this.$_storeSavedJob({ job_uuid: this.jobUuid }).then(() => {
                    this.$_PUT_JOB_EVENT({ job: this.jobUuid, status: 'is_saved' });
                    this.$_SAVE_JOB_AFTER_LOGIN('');
                }).finally(() => {
                    this.spinner = false;
                });
            },

            destroySavedJob() {
                this.spinner = true;
                this.$_destroySavedJob(this.jobUuid).finally(() => {
                    this.$_PUT_JOB_EVENT({ job: this.jobUuid, status: 'is_saved' });
                    this.spinner = false;
                });
            },
        },
    };
</script>
